__turbopack_context__.v({
  "message": "SectionErrorFallback-module__FIYajW__message",
  "section": "SectionErrorFallback-module__FIYajW__section",
  "title": "SectionErrorFallback-module__FIYajW__title",
});
